<template>
  <div  :class="status!=='draft' ? 'bg-aquamarine border-aquamarine' : 'bg-blue-400 border-blue-500'" class="flex py-1 px-4 lg:px-6 items-center justify-center border bg-opacity-10 rounded-full text-center mr-3 lg:mr-10">
      <div :class="status!=='draft' ? 'text-aquamarine' : 'text-blue-400 '" class="text-sm flex items-center space-x-2">
      <span>{{status}}</span>
      <template v-if="status ==='posted'">
        <CheckedMark/>
      </template>
      <template v-else-if="status === 'draft'">
        <EditIcon/>
      </template>
      <template v-else-if="status === 'scheduled'">
        <CurvedArrowIcon/>
      </template>
    </div>
  </div>
</template>

<script>
import CheckedMark from '@/components/svg/CheckedMark';
import EditIcon from '@/components/svg/EditIcon';
import CurvedArrowIcon from '@/components/svg/CurvedArrow';

export default {
  name:"BadgeStatus",
  
  components: {
    CheckedMark,
    EditIcon,
    CurvedArrowIcon
  },

  props: {
    status: {
      type: String,
      default: "draft",
    },
  },
}
</script>